import { render, staticRenderFns } from "./CanceledOpportunities.vue?vue&type=template&id=5de10a3a&scoped=true&"
import script from "./CanceledOpportunities.vue?vue&type=script&lang=js&"
export * from "./CanceledOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./CanceledOpportunities.vue?vue&type=style&index=0&id=5de10a3a&prod&lang=css&"
import style1 from "./CanceledOpportunities.vue?vue&type=style&index=1&id=5de10a3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de10a3a",
  null
  
)

export default component.exports